/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["es"] = {
    wikiLinkLabel:  "Discute"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/es/timeline.js
// module id = 577
// module chunks = 3